module.exports = __webpack_public_path__ + "media/images/dashboard/hand-fdca2b5cade268a7ea1b3c089054bffa.svg";